import { createRoute } from '@tanstack/react-router'
import { ProfileFormPage } from '@/features/profiles/pages/ProfileFormPage'
import { Route as profilesRoute } from '../profiles'

export const Route = createRoute({
  getParentRoute: () => profilesRoute,
  path: '/add',
  component: ProfileFormPage,
})
